// extracted by mini-css-extract-plugin
export default {"container":"RocketCollection_container__k7cZr"};